var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-cascader',{ref:"cascader",staticStyle:{"width":"358px"},attrs:{"placeholder":"搜索","size":"mini","options":_vm.publisherOptions,"value":_vm.noticeReceiver,"filterable":"","clearable":""},on:{"change":_vm.change}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }